var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"datetime":_vm.utc,"title":_vm.tooltip}},[_vm._v(_vm._s(_vm.prefix + _vm.formatted + _vm.suffix))])}
var staticRenderFns = []

export { render, staticRenderFns }